import SetPassword from "../../Components/SetPassword/Setpassword";

export default function SetPasswordPage(){
    return(
        <SetPassword/>
    )
}